import React from 'react'

import KinerjaKonfirmasiProfilApp from 'app/KinerjaPage/pages/KonfirmasiProfil'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { useAPIKinerja } from 'api/kinerja/useAPIKinerja'
import { PageGuardGuru } from 'app/KinerjaPage/components/PageGuardGuru'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled']

    if (!isKinerjaEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    return { props: {} }
  },
})

const KinerjaKonfirmasiProfil = () => {
  const {
    data: { data: skp } = {},
    isFetched: isSKPFetched,
    isLoading: isSKPLoading,
  } = useAPIKinerja()

  return (
    <PageGuardGuru>
      <KinerjaKonfirmasiProfilApp
        skp={skp}
        isSKPFetched={isSKPFetched}
        isSKPLoading={isSKPLoading}
      />
    </PageGuardGuru>
  )
}

KinerjaKonfirmasiProfil.Layout = KinerjaLayout

KinerjaKonfirmasiProfil.layoutOpts = {
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
}

export default KinerjaKonfirmasiProfil
